import React from "react";

const SuccessIcon = ({ width = 54, height = 52 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 54 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30.5896" cy="29.0584" r="22.9412" fill="#29D398" />
    <path
      d="M37.3896 19.4996C37.3896 19.4996 22.7256 34.3196 22.6216 34.3716C22.0496 34.9436 21.1136 34.9436 20.5416 34.3716L13.3656 27.1436C12.7936 26.5716 12.7936 25.6356 13.3136 25.0636C13.8856 24.4916 14.8216 24.4916 15.3936 25.0116C15.3936 25.0116 15.3936 25.0116 15.4456 25.0636L21.6336 31.2516L35.3616 17.4196C35.9336 16.8476 36.8696 16.8476 37.4416 17.4196C37.9616 17.9916 37.9616 18.9276 37.3896 19.4996ZM49.4016 25.9996C49.4016 38.9476 38.9496 49.3996 26.0016 49.3996C13.0536 49.3996 2.60156 38.9476 2.60156 25.9996C2.60156 13.0516 13.0536 2.59961 26.0016 2.59961C38.9496 2.59961 49.4016 13.0516 49.4016 25.9996ZM46.5416 25.9996C46.5416 14.6636 37.3376 5.51161 26.0016 5.51161C14.7176 5.51161 5.51356 14.6636 5.51356 25.9996V26.0516C5.51356 37.3876 14.7176 46.5396 26.0536 46.5396C37.3896 46.4876 46.5416 37.3356 46.5416 25.9996Z"
      fill="black"
    />
  </svg>
);

export default SuccessIcon;

